module.exports = __webpack_public_path__ + "static/media/dysmate-logo-cropped.2c314661.jpg";